import { createContext, useContext } from "react";
import type { PolicyName } from "./policies";

export interface PermissionsContextValue {
    /** Outcome BY policy name; capabilities are resolved in usePermission. */
    readonly permissions: Partial<Record<PolicyName, boolean>>;
    readonly isLoading: boolean;
}

/**
 * Fail-closed default: outside the provider (or in tests without a wrapper)
 * every permission comes out denied and nothing is loading.
 */
export const PermissionsContext = createContext<PermissionsContextValue>({
    permissions: {},
    isLoading: false,
});

export const usePermissionsContext = (): PermissionsContextValue =>
    useContext(PermissionsContext);
